import { ACCOUNT__MUTATIONS } from "../mutation-types";
import { ACCOUNT__ACTIONS } from "../action-types";

// State
const state = {
    accountno: null,
};

//Mutations
const mutations = {
    [ACCOUNT__MUTATIONS.ACCOUNTNO](state, data) {
        state.accountno = data;
    },
};

// Actions
const actions = {
    async [ACCOUNT__ACTIONS.ACCOUNTNO]({ commit, state }, data) {
        try {
            commit(ACCOUNT__MUTATIONS.ACCOUNTNO, data);
        } catch (error) {
            console.log(error);
        }
    },
};

export default {
    namespaced: true,
    strict: process.env.NODE_ENV !== "production",
    state,
    mutations,
    actions,
};
